export const isEmailAndIdExist = (): boolean => {
  const searchParams = new URLSearchParams(window.location.search);
  const email = searchParams.get("email");
  const id = searchParams.get("id");
  return !!email && !!id;
};
